import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { ReviewComponent } from '../review/review.component';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ResubmitCheckerComponent } from '../resubmit-checker/resubmit-checker.component';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css']
})
export class MonitoringComponent implements OnInit {
  @Input() monitoringList: any;
  @Input() ifReviewAssesment: any;
  @Input() ifResubmitAssesment: boolean = false;
  quesLanguage!: string;
  assessment!: any;
  subscription!: Subscription;
  assessmentDetails: any;
  isArabic!: boolean;
  isAssessmentStarted!: boolean;
  isChecker = this.storageService.getSessionStorageData('isChecker');
  userDetails: any;
  rejectedAssessmentsCount: any = 0;
  isMakerCheckerEnabled: any;
  fetchTotalNoOfQuesResponse!: any;
  constructor(private activateRoute: ActivatedRoute, private route: Router,
    private assessmentService: AssessmentService,
    private commonService: CommonService,
    private storageService: StorageService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.calculateRejectedAssessments();
  }

  calculateRejectedAssessments() {

    const REJECTED_STATUS = GlobalConstants.STATUSES.REJECTED.name;

    const rqstBody = { assessmentUnit: this.userDetails?.assessmentUnitValue, contactguid: this.userDetails?.contactguid };
    this.assessmentService.fetchSubmittedQuestionnaires(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get submitted questionnaire list in assessment: ', decryptedData);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      let questionnaireList = resp?.questionnaires?.filter((ques: any) => ques.questionnaireStatus
        == REJECTED_STATUS && ques.questionnaireMdeValue != null);
      //console.log('list of submitted questionnaires: ', questionnaireList);

      //let selectedQuestionnaire;
      this.rejectedAssessmentsCount = questionnaireList?.length;
    });
  }

  selectAssessment() {
    let assessmentIdx!: number;
    this.monitoringList.forEach((v: any, i: any) => {
      if (v.value === 'Review and Approval') {
        assessmentIdx = i;
      }
    });
    this.onListItemClick(assessmentIdx);
  }

  onListItemClick(selectedItemIdx: number) {
    this.monitoringList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
    this.ifReviewAssesment = this.monitoringList[selectedItemIdx].value === 'Review and Approval';

    if (this.monitoringList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.monitoringList[selectedItemIdx].link;
      this.route.navigate([path]);
    }

  }

  goToGeneralAssessment() {
    if (!this.ifResubmitAssesment) {
      if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].name == "General" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].totalcount > 0) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General' } });
      }
      else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].name == "Inherent Risk" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].totalcount > 0) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Inherent Risk' } });
      }
      else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].name == "Controls" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].totalcount > 0) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Controls' } });
      }
      else {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General' } });
      }
    }
    else if (this.ifResubmitAssesment) {
      if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].name == "General" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].totalcount > 0 &&
        (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].draft > 0 ||
          this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].rejected > 0)
      ) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'resubmit' } });
      }
      else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].name == "Inherent Risk" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].totalcount > 0 &&
        (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].draft > 0 ||
          this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].rejected > 0)
      ) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Inherent Risk', action: 'resubmit' } });
      }
      else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].name == "Controls" &&
        this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].totalcount > 0 &&
        (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].draft > 0 ||
          this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].rejected > 0)
      ) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Controls', action: 'resubmit' } });
      }
      else {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'resubmit' } });
      }
    }
  }

  subscribeToEmitter(componentRef: any) {
    if (!(componentRef instanceof ReviewComponent || componentRef instanceof ResubmitCheckerComponent)) {
      return;
    }
    const child: any = componentRef;
    this.subscription = child.questionnaireEvent.subscribe((data: any) => {
      // console.log('assessment details in monitoring: ', data);
      if (data) {
        this.assessment = JSON.parse(data);
        this.assessmentDetails = {
          questionnaireName: this.assessment.questionnaireName,
          questionnaireguid: this.assessment.questionnaireMdeValue,
          questionnaireProgress: this.assessment.questionnaireProgress,
          assessmentUnit: this.assessment.assessmentUnit.name,
          assessmentunitguid: this.assessment.assessmentUnit.value,
          targetDate: this.assessment.targetDate,
          questionnaireAccountGuid: this.assessment.questionnaireAccountGuid
        }
        this.storageService.setSessionStorageData('quesStatus', this.assessmentDetails?.questionnaireProgress);
        let rqstBody = {
          questionnaire: this.assessment.questionnaireMdeValue,
          assessmentUnit: this.assessment.assessmentUnit.value,
          isChecker: this.isChecker,
          isMakerCheckerEnabled: this.isMakerCheckerEnabled
        };
        this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
          let decryptedData = this.commonService.decryptUsingAES256(res?.data);
          let resp = JSON.parse(JSON.stringify(decryptedData));
          this.fetchTotalNoOfQuesResponse = resp;
          // console.log('finally number of questions: ', resp);
          let progressDetails = resp;
          // progressDetails.questionnaireProgress = this.assessmentDetails.questionnaireProgress;
          progressDetails.assessmentName = this.assessmentDetails.questionnaireName;
          this.assessmentDetails['totalQues'] = resp.totalQuestions;
          this.assessmentDetails['answeredCount'] = resp.totalReviewedAnswers;
          if (resp.totalReviewedAnswers > 0) {
            this.isAssessmentStarted = true;
          } else {
            this.isAssessmentStarted = false;
          }
          this.storageService.setSessionStorageData('assessmentDetails', this.assessmentDetails);

          this.storageService.setSessionStorageData('answeredQues', this.assessmentDetails?.answeredCount);
          this.storageService.setSessionStorageData('totalQues', this.assessmentDetails?.totalQues);
        });
      } else {
        this.assessment = null;
      }
    });
  }

}
